import ApplicationSubmissionModal from './ApplicationSubmissionModal';

export default ApplicationSubmissionModal;
